import { Box, Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import { Grid } from '@mui/system';
import { usePdfConfiguration } from 'app/hooks';
import { Breadcrumb, Button, DetailWrapperDiv, FileUpload, TextField, Typography } from 'app/shared';
import { t } from 'i18next';

export const PdfConfiguration = () => {
  const { loading, updateForm, downloadLogo, uploadLogo, detail } = usePdfConfiguration();

  const { bindTextField, bindCheckbox, submit } = updateForm;

  return (
    <>
      <Breadcrumb />
      <DetailWrapperDiv>
        <Typography detailTitle>{t('pdfConfig.title')}</Typography>
        <Grid container spacing={4}>
          <Grid size={12} display={'flex'} justifyContent={'center'} gap={2}>
            <FileUpload label={t('pdfConfig.uploadLogo')} onFileSelect={uploadLogo} />
            {detail?.has_logo && <Button onClick={downloadLogo}>{t('actions.download')}</Button>}
          </Grid>
          <Grid size={6}>
            <TextField
              multiline
              rows={3}
              label={t('pdfConfig.companyName')}
              {...bindTextField({ field: 'header_title' })}
            />
          </Grid>
          <Grid size={6}>
            <TextField
              multiline
              rows={3}
              label={t('pdfConfig.address')}
              {...bindTextField({ field: 'header_subtitle' })}
            />
          </Grid>
          <Grid size={6}>
            <TextField
              multiline
              rows={3}
              label={t('pdfConfig.privacyPolicy')}
              {...bindTextField({ field: 'privacy_policy' })}
            />
          </Grid>
          <Grid size={6}>
            <TextField
              multiline
              rows={3}
              label={t('pdfCongif.preResultText')}
              {...bindTextField({ field: 'free_text_1' })}
            />
          </Grid>
          <Grid size={6}>
            <Typography padding={2}>{t('pdfConfig.patientDataOptions')}</Typography>
            <FormGroup>
              <FormControlLabel
                control={<Checkbox {...bindCheckbox({ field: 'patient_data_options', path: ['show_birth_date'] })} />}
                label={t('pdfConfig.showBirthDate')}
              />
              <FormControlLabel
                control={<Checkbox {...bindCheckbox({ field: 'patient_data_options', path: ['show_tax_code'] })} />}
                label={t('pdfConfig.showTaxCode')}
              />
              <FormControlLabel
                control={<Checkbox {...bindCheckbox({ field: 'patient_data_options', path: ['show_company'] })} />}
                label={t('pdfConfig.showCompany')}
              />
              <FormControlLabel
                control={<Checkbox {...bindCheckbox({ field: 'patient_data_options', path: ['show_job_title'] })} />}
                label={t('pdfConfig.showJobTitle')}
              />
              <FormControlLabel
                control={<Checkbox {...bindCheckbox({ field: 'patient_data_options', path: ['show_residence'] })} />}
                label={t('pdfConfig.showResidence')}
              />
            </FormGroup>
          </Grid>
          <Grid size={6}>
            <Typography padding={2}>{t('pdfConfig.reportDataOptions')}</Typography>
            <FormGroup>
              <FormControlLabel
                control={<Checkbox {...bindCheckbox({ field: 'report_data_options', path: ['show_comment'] })} />}
                label={t('pdfConfig.showComment')}
              />
              <FormControlLabel
                control={<Checkbox {...bindCheckbox({ field: 'report_data_options', path: ['show_temperature'] })} />}
                label={t('pdfConfig.showTemperature')}
              />
              <FormControlLabel
                control={
                  <Checkbox {...bindCheckbox({ field: 'report_data_options', path: ['show_urine_quantity'] })} />
                }
                label={t('pdfConfig.showUrineQuantity')}
              />
              <FormControlLabel
                control={<Checkbox {...bindCheckbox({ field: 'report_data_options', path: ['show_doctor_name'] })} />}
                label={t('pdfConfig.showDoctorName')}
              />
              <FormControlLabel
                control={
                  <Checkbox {...bindCheckbox({ field: 'report_data_options', path: ['show_execution_date'] })} />
                }
                label={t('pdfConfig.showExecutionDate')}
              />
              <FormControlLabel
                control={
                  <Checkbox {...bindCheckbox({ field: 'report_data_options', path: ['show_reporting_date'] })} />
                }
                label={t('pdfConfig.showReportingDate')}
              />
              <FormControlLabel
                control={<Checkbox {...bindCheckbox({ field: 'report_data_options', path: ['show_times'] })} />}
                label={t('pdfConfig.showTimes')}
              />
              <FormControlLabel
                control={
                  <Checkbox {...bindCheckbox({ field: 'report_data_options', path: ['show_patient_signature'] })} />
                }
                label={t('pdfConfig.showPatientSignature')}
              />
              <FormControlLabel
                control={
                  <Checkbox {...bindCheckbox({ field: 'report_data_options', path: ['show_doctor_signature'] })} />
                }
                label={t('pdfConfig.showDoctorSignature')}
              />
            </FormGroup>
          </Grid>
        </Grid>
        <Box padding={4}>
          <Button sx={{ margin: 1 }} variant="contained" loading={loading} onClick={submit}>
            {t('actions.saveUpdate')}
          </Button>
        </Box>
      </DetailWrapperDiv>
    </>
  );
};
